import { EnumUserRole, EnumUserType, User } from 'lib/graphql';
import { CustomerFormValues } from './customer-validation';

// Gets user type options filtered by current user role
export function getUserTypeOptions(currentUserRole?: EnumUserRole) {
  const allTypes = Object.values(EnumUserType);
  const filteredTypes =
    currentUserRole === EnumUserRole.Vendor
      ? allTypes.filter((t) => t !== EnumUserType.Processor)
      : allTypes;

  return filteredTypes.map((k) => ({
    label: k.charAt(0).toUpperCase() + k.slice(1),
    value: k,
  }));
}

// Builds relationships array based on user type and vendor
export function buildUserRelationships(
  userType: EnumUserType | undefined,
  vendorId: string | undefined,
  producerId?: string,
) {
  if (!vendorId) {
    return [] as Array<{
      vendorId?: string;
      producerId?: string;
      type?: EnumUserType;
    }>;
  }

  if (userType === EnumUserType.Buyer) {
    return [
      {
        vendorId,
        ...(producerId ? { producerId } : {}),
        type: EnumUserType.Buyer,
      },
    ];
  }

  if (userType === EnumUserType.Producer) {
    return [
      {
        vendorId,
        type: EnumUserType.Producer,
      },
    ];
  }

  return undefined;
}

// Converts customer data to form initial values
export function customerToFormValues(
  customer: User | null | undefined,
  forcedType?: EnumUserType,
  vendorId?: string,
): CustomerFormValues {
  const existingRelationship =
    customer?.relationships?.find((r) =>
      vendorId ? String(r?.vendorId) === String(vendorId) : false,
    ) || customer?.relationships?.[0];
  const mapRelationshipTypeToUserType = (
    t: unknown,
  ): EnumUserType | undefined => {
    // GraphQL may generate a distinct enum for relationship.type; map by value
    if (!t) return undefined;
    const val = String(t).toLowerCase();
    if (val === String(EnumUserType.Buyer).toLowerCase())
      return EnumUserType.Buyer;
    if (val === String(EnumUserType.Producer).toLowerCase())
      return EnumUserType.Producer;
    return undefined;
  };
  return {
    first_name: customer?.first_name || '',
    last_name: customer?.last_name || '',
    email: customer?.email || '',
    phone: customer?.phone || '',
    company: customer?.company || '',
    address_street: customer?.address?.address_1 || '',
    address_street2: customer?.address?.address_2 || '',
    address_city: customer?.address?.city || '',
    address_state: customer?.address?.state || '',
    address_postcode: customer?.address?.postcode || '',
    type:
      forcedType ??
      mapRelationshipTypeToUserType(existingRelationship?.type) ??
      undefined,
    relationships: {
      producerId: existingRelationship?.producerId || undefined,
    },
  };
}
